export default __webpack_public_path__ + "static/media/Links-BlankIMGs-01.53f99c09.svg";